module.exports = __webpack_public_path__ + "img/jpm_icons3.a097da3f.png";